/* eslint-disable */
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
import AdministrationConfigurations from 'views/configurations/index';
import Demographics from 'views/user-profile/Demographics';
import TripDetails from 'views/trip/TripDetails';
import AcquiatlProcess from 'views/acquital/index';
import { useRole } from 'hooks/api/roles/context';
import TripPreview from 'views/administration/request-acquital/travel-request-form';
import AcquittalPreview from 'views/administration/request-acquital/travel-acquital-form';
import BuildInfoPage from 'utils/bulidNumber';
import AcquittalsTable from 'views/administration/finance/acquittal-table';
import FinanceOfficerRequests from 'views/administration/finance/finance-officer-requests';
import FinanceOfficerAcquittals from 'views/administration/finance/finance-officer-acquittals';

// Component imports
const DashboardDefault = Loadable(lazy(() => import('views/dashboard')));
const DashboardAdminDefault = Loadable(lazy(() => import('views/administration/dashboard/index')));
const GlobalTracker = Loadable(lazy(() => import('views/administration/tracker/index')));
const TripDefault = Loadable(lazy(() => import('views/trip')));
const Reporting = Loadable(lazy(() => import('views/administration/reporting')));
const TripAdministrationDefaults = Loadable(lazy(() => import('views/administration/request-acquital/index')));
const TripAdministrationDefaulth = Loadable(lazy(() => import('views/administration/request-acquital/index')));
const TripAdministrationDefaultf = Loadable(lazy(() => import('views/administration/request-acquital/index')));
const AccountManagement = Loadable(lazy(() => import('views/user-profile/AccountManagment')));
const AdminPortal = Loadable(lazy(() => import('views/administration/portal/index')));
const UpcomingTrips = Loadable(lazy(() => import('views/upcoming-trips')));

// Role-based route guard component
const RoleGuard = ({ children, allowedRoles }) => {
    const { roles } = useRole();

    // Extract role names from the roles array
    const userRoles = roles.filter(role => role.active === true).map((role) => role.role.name);

    // Check if any of the user's roles match the allowed roles
    const hasAccess = allowedRoles.some((role) => userRoles.includes(role));

    if (!hasAccess) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

// Route configurations with role permissions
const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/dashboard',
            element: (
                <RoleGuard allowedRoles={['ROLE_EMPLOYEE', 'ROLE_SUPERVISOR', 'ROLE_HOD', 'ROLE_FINANCE', 'ROLE_ACCOUNTANT']}>
                    <DashboardDefault />
                </RoleGuard>
            )
        },
        {
            path: '/dashboard/default',
            element: (
                <RoleGuard allowedRoles={['ROLE_EMPLOYEE', 'ROLE_SUPERVISOR', 'ROLE_HOD', 'ROLE_FINANCE', 'ROLE_ACCOUNTANT']}>
                    <DashboardDefault />
                </RoleGuard>
            )
        },
        {
            path: '/dashboard/default-admin',
            element: (
                <RoleGuard allowedRoles={['ROLE_SUPERVISOR', 'ROLE_HOD', 'ROLE_FINANCE']}>
                    <DashboardAdminDefault />
                </RoleGuard>
            )
        },
        {
            path: '/dashboard/my-trips',
            element: (
                <RoleGuard allowedRoles={['ROLE_EMPLOYEE', 'ROLE_SUPERVISOR', 'ROLE_HOD', 'ROLE_FINANCE']}>
                    <TripDefault />
                </RoleGuard>
            )
        },
        // Supervisor
        {
            path: '/dashboard/trips-adminstration-s',
            element: (
                <RoleGuard allowedRoles={['ROLE_SUPERVISOR']}>
                    <TripAdministrationDefaults givenRole="ROLE_SUPERVISOR" />
                </RoleGuard>
            )
        },
        // Finance
        {
            path: '/dashboard/trips-adminstration-f',
            element: (
                <RoleGuard allowedRoles={['ROLE_FINANCE']}>
                    <TripAdministrationDefaultf givenRole="ROLE_FINANCE" />
                </RoleGuard>
            )
        },
        // Hod
        {
            path: '/dashboard/trips-adminstration-h',
            element: (
                <RoleGuard allowedRoles={['ROLE_HOD']}>
                    <TripAdministrationDefaulth givenRole="ROLE_HOD" />
                </RoleGuard>
            )
        },
        {
            path: '/dashboard/reports',
            element: (
                <RoleGuard allowedRoles={['ROLE_FINANCE', 'ROLE_ACCOUNTANT', 'ROLE_SUPERVISOR', 'ROLE_AUDITOR']}>
                    <Reporting />
                </RoleGuard>
            )
        },
        {
            path: '/dashboard/acquitals-accounts',
            element: (
                <RoleGuard allowedRoles={['ROLE_FINANCE', 'ROLE_ACCOUNTANT', 'ROLE_SUPERVISOR', 'ROLE_HOD']}>
                    <AcquittalsTable />
                </RoleGuard>
            )
        },
        {
            path: '/dashboard/account',
            element: (
                <RoleGuard allowedRoles={['ROLE_EMPLOYEE', 'ROLE_SUPERVISOR', 'ROLE_HOD', 'ROLE_FINANCE', 'ROLE_ACCOUNTANT']}>
                    <TripDefault />
                </RoleGuard>
            )
        },
        {
            path: '/dashboard/notifications',
            element: (
                <RoleGuard allowedRoles={['ROLE_EMPLOYEE', 'ROLE_SUPERVISOR', 'ROLE_HOD', 'ROLE_FINANCE', 'ROLE_ACCOUNTANT']}>
                    <TripDefault />
                </RoleGuard>
            )
        },
        {
            path: '/configurations',
            element: (
                <RoleGuard allowedRoles={['ROLE_SUPERVISOR', 'ROLE_HOD', 'ROLE_EMPLOYEE']}>
                    <AdministrationConfigurations />
                </RoleGuard>
            )
        },
        {
            path: '/ui',
            element: (
                <RoleGuard allowedRoles={['ROLE_ACCOUNTANT', 'ROLE_EMPLOYEE', 'ROLE_SUPERVISOR', 'ROLE_HOD', 'ROLE_FINANCE']}>
                    <Demographics />
                </RoleGuard>
            )
        },
        {
            path: '/acquital-process/:requestId',
            element: (
                <RoleGuard allowedRoles={['ROLE_EMPLOYEE', 'ROLE_SUPERVISOR', 'ROLE_HOD']}>
                    <AcquiatlProcess />
                </RoleGuard>
            )
        },
        {
            path: '/trip/:requestId',
            element: (
                <RoleGuard allowedRoles={['ROLE_EMPLOYEE', 'ROLE_SUPERVISOR', 'ROLE_HOD']}>
                    <TripDetails />
                </RoleGuard>
            )
        },
        {
            path: '/trip-administration-request/:requestId',
            element: (
                <RoleGuard allowedRoles={['ROLE_SUPERVISOR', 'ROLE_HOD', 'ROLE_FINANCE']}>
                    <TripPreview />
                </RoleGuard>
            )
        },
        {
            path: '/trip-administration-acquital/:acquittalId',
            element: (
                <RoleGuard allowedRoles={['ROLE_SUPERVISOR', 'ROLE_HOD', 'ROLE_FINANCE']}>
                    <AcquittalPreview />
                </RoleGuard>
            )
        },
        {
            path: '/settings',
            element: (
                <RoleGuard allowedRoles={['ROLE_SUPERVISOR', 'ROLE_HOD', 'ROLE_FINANCE', 'ROLE_EMPLOYEE']}>
                    <AccountManagement />
                </RoleGuard>
            )
        },
        {
            path: '/build-number',
            element: (
                <RoleGuard allowedRoles={['ROLE_SUPERVISOR', 'ROLE_HOD', 'ROLE_FINANCE', 'ROLE_EMPLOYEE']}>
                    <BuildInfoPage />
                </RoleGuard>
            )
        },
        {
            path: '/admin-portal',
            element: (
                <RoleGuard allowedRoles={[ 'ROLE_SUPERUSER', 'ROLE_ADMIN','ROLE_SUPERVISOR']}>
                    <AdminPortal />
                </RoleGuard>
            )
        },
        {
            path: '/dashboard/upcoming-trips',
            element: (
                <RoleGuard allowedRoles={['ROLE_SUPERVISOR', 'ROLE_HOD', 'ROLE_FINANCE', 'ROLE_ADMIN_OFFICER','ROLE_SUPERUSER']}>
                    <UpcomingTrips />
                </RoleGuard>
            )
        },
        {
            path: '/finance-officer/requests',
            element: (
                <RoleGuard allowedRoles={['ROLE_ACCOUNTANT', 'ROLE_SUPERVISOR', 'ROLE_FINANCE', 'ROLE_ACCOUNTANT','ROLE_SUPERUSER']}>
                    <FinanceOfficerRequests />
                </RoleGuard>
            )
        },
        {
            path: '/finance-officer/acquittals',
            element: (
                <RoleGuard allowedRoles={['ROLE_ACCOUNTANT', 'ROLE_SUPERVISOR', 'ROLE_FINANCE', 'ROLE_ACCOUNTANT','ROLE_SUPERUSER']}>
                    <FinanceOfficerAcquittals />
                </RoleGuard>
            )
        },
        {
            path: '/dashboard/tracker',
            element: (
                <RoleGuard allowedRoles={['ROLE_ADMIN', 'ROLE_SUPERUSER', 'ROLE_SUPERVISOR']}>
                    <GlobalTracker />
                </RoleGuard>
            )
        }
    ]
   
};

export default MainRoutes;
